import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './private/components/NavbarPrivate';
import SideMenu from './private/components/SideMenu';
import { decrypt } from './encryption/Encryption';

const Private = () => {
  const [isMinimized, setIsMinimized] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isUserAuthenticated = sessionStorage.getItem('ans-sms') || '';
  const [sessionMessage, setSessionMessage] = useState(location.state?.warning || '');
  const [successMessage, setSuccessMessage] = useState(location.state?.success || '');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSessionMessage('');
      setSuccessMessage('');
    }, 5000);
    return () => clearTimeout(timeout);
  }, [sessionMessage, successMessage]);

  useEffect(() => {
    if (isUserAuthenticated === '') {
      sessionStorage.removeItem('ans-sms');
      navigate('/public/login', {
        state: {
          warning: 'Please login to access page!',
        },
      });
    }
  }, [isUserAuthenticated, navigate]);

  if (isUserAuthenticated === '') {
    return null;
  }

  let userInfo;

  try {
    userInfo = decrypt(isUserAuthenticated);
  } catch (error) {
    setErrorMessage('Error while parsing JSON');
  }

  if (!userInfo) {
    sessionStorage.removeItem('ans-sms');
    navigate('/public/login', {
      state: {
        warning: 'Please login to access page!',
      },
    });
    return null;
  }

  const handleLogout = (e) => {
    e.preventDefault();
    // Clear the localStorage
    localStorage.removeItem('ans-sms');

    // Clear the session storage
    sessionStorage.removeItem('ans-sms');
    navigate('/public/login');
  };

  return (
    <div className="min-h-screen bg-private">
      {/* Message Notifications */}
      {(sessionMessage || successMessage || errorMessage) && (
        <div className="fixed top-4 right-4 z-50 space-y-2">
          {sessionMessage && (
            <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded-lg shadow-lg">
              <div className="flex items-center">
                <span className="font-medium">{sessionMessage}</span>
              </div>
            </div>
          )}
          {successMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg shadow-lg">
              <div className="flex items-center">
                <span className="font-medium">{successMessage}</span>
              </div>
            </div>
          )}
          {errorMessage && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg shadow-lg">
              <div className="flex items-center">
                <span className="font-medium">{errorMessage}</span>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="flex">
        {/* Sidebar */}
        <div className={`fixed inset-y-0 left-0 z-30 transition-all duration-300 ${isMinimized ? 'w-18' : 'w-64'}`}>
          <SideMenu isMinimized={isMinimized} setIsMinimized={setIsMinimized} />
        </div>

        {/* Main Content */}
        <div className={`flex-1 transition-all duration-300 ${isMinimized ? 'ml-16' : 'ml-72'}`}>
          {/* Top Navigation */}
          <div className="sticky top-0 z-20 bg-private shadow-lg">
            <Navbar logout={handleLogout} errorMsg={errorMessage} />
          </div>

          {/* Page Content */}
          <main className="min-h-screen bg-private">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Private;
